'use client';
import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { Icon } from '@ui/icons';
import {
  StyledFloatingCtaContainer,
  StyledFloatingCtaButton,
  IconContainer,
  CloseButtonContianer,
  TextContainer,
} from './styles';

export const FloatingCta = ({
  href,
  onCtaClick,
  onCloseClick,
  text,
  icons,
  mobileOnly = false,
}) => {
  const handleCloseButtonClick = e => {
    e.stopPropagation();
    e.preventDefault();
    onCloseClick();
  };

  return (
    <StyledFloatingCtaContainer $mobileOnly={mobileOnly}>
      <StyledFloatingCtaButton href={href} onClick={onCtaClick} target="_blank">
        {icons?.length && (
          <IconContainer>
            {icons?.map((icon, i) => (
              <Image src={icon.src} alt={icon.alt} key={i} />
            ))}
          </IconContainer>
        )}
        {text && <TextContainer>{text}</TextContainer>}
        <CloseButtonContianer
          onClick={handleCloseButtonClick}
          data-testid="Floating-cta-close-button"
        >
          <Icon iconName="close" size="26px" id="close" color="text.lightest" />
        </CloseButtonContianer>
      </StyledFloatingCtaButton>
    </StyledFloatingCtaContainer>
  );
};

FloatingCta.displayName = 'FloatingCta';

FloatingCta.propTypes = {
  href: PropTypes.string.isRequired,
  onCtaClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  text: PropTypes.string,
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.object.isRequired,
      alt: PropTypes.string.isRequired,
    }),
  ),
  mobileOnly: PropTypes.bool,
};
